import {
  REQUEST_INBOX_STATUS,
  FETCHING_INBOX_STATUS,
  GET_INBOX_STATUS_FAILED,
} from './actions';

export const initialState = {
  fetching: false,
  isInboxActive: false,
};

export const reducer = (state, action) => {
  let { type, payload } = action;
  switch (type) {
    case REQUEST_INBOX_STATUS:
      return {
        ...state,
        fetching: false,
        isInboxActive: payload.isActive,
      };
    case FETCHING_INBOX_STATUS:
      return {
        ...state,
        fetching: true,
      };
    case GET_INBOX_STATUS_FAILED:
      return {
        ...state,
        fetching: false,
      };
    default:
      return state;
  }
};
